import React, { Component } from 'react';
import { Container, Col, Button, Row } from 'reactstrap';

import { withTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import NahibuHelmet from '../components/nahibu-helmet';
import nahibuIcon from '../images/icon/nahibu-icon.png';
import nahibuIcon2 from '../images/icon/nahibu-icon2.png';

class Error404 extends Component {
	constructor(props) {
		super(props);
		this.state = {
			mouseOn: false,
		};

		this.changeImageState = this.changeImageState.bind(this);
	}

	changeImageState() {
		this.setState({
			mouseOn: !this.state.mouseOn,
		});
	}

	render() {
		const t = this.props.t;

		return (
			<>
				<NahibuHelmet title={'Nahibu'} 
                 noindex={true}
                description={t('404|page introuvable')} />
				{/* Qui sommes nous ?  */}
				<Container fluid className="full-page-center bg-opacity">
					<Container>
						<Row>
							<Col md={6} className="margin-auto">
								<h1 className="title-404 white">{t('404|Oups...')}</h1>
								<p className="white pb-2">{t('404|La page que vous recherchez est introuvable')}</p>
								<Button href={'/'} className="btn-nah">
									{t("404|Retour à l'accueil")}
								</Button>
							</Col>
							<Col md={6} className="full-page right pt-5">
								<LazyLoadImage onMouseOver={this.changeImageState} onMouseOut={this.changeImageState} className={this.state.mouseOn ? "image-404-hover" : "image-404"} alt={t("404|Nahibu startup rennaise")} src={nahibuIcon2} />
								<LazyLoadImage onMouseOver={this.changeImageState} onMouseOut={this.changeImageState} className={this.state.mouseOn ? "image2-404-hover" : "image2-404"} alt={t("404|Nahibu startup rennaise")} src={nahibuIcon} />
							</Col>
						</Row>
					</Container>
				</Container>
			</>
		);
	}
}

export default withTranslation()(Error404);
